let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6hW9n")).then(() => parcelRequire('b6O1u'));